import React, { useState } from 'react';

const PriceFilter = ({ priceRange, setPriceRange }) => {
  const [minPrice, setMinPrice] = useState(priceRange[0]);
  const [maxPrice, setMaxPrice] = useState(priceRange[1]);

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxPrice);
    setMinPrice(value);
    setPriceRange([value, maxPrice]);
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minPrice);
    setMaxPrice(value);
    setPriceRange([minPrice, value]);
  };

  return (
    <div className="price-filter">
      <h4 className="filter-subtitle">Price Range</h4>
      <div className="price-inputs">
        <div className="price-input-group">
          <label htmlFor="min-price">Min</label>
          <input
            id="min-price"
            type="number"
            min="0"
            max="10000"
            value={minPrice}
            onChange={handleMinChange}
            className="price-input"
          />
        </div>
        <div className="price-separator">-</div>
        <div className="price-input-group">
          <label htmlFor="max-price">Max</label>
          <input
            id="max-price"
            type="number"
            min="0"
            max="10000"
            value={maxPrice}
            onChange={handleMaxChange}
            className="price-input"
          />
        </div>
      </div>

      <div className="price-range-slider">
        <input
          type="range"
          min="0"
          max="10000"
          value={minPrice}
          onChange={handleMinChange}
          className="price-range-input min"
        />
        <input
          type="range"
          min="0"
          max="10000"
          value={maxPrice}
          onChange={handleMaxChange}
          className="price-range-input max"
        />
      </div>

      <div className="price-display">
        ₹{minPrice.toLocaleString()} - ₹{maxPrice.toLocaleString()}
      </div>
    </div>
  );
};

export default PriceFilter;
